"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.customerReducer = exports.setCustomer = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    customer: {},
};
// only the profile's working copy lives here: the customer list and record come from customersApi
var slice = (0, toolkit_1.createSlice)({
    name: "customers",
    initialState: initialState,
    reducers: {
        setCustomer: function (state, action) {
            state.customer = action.payload;
        },
    },
});
var setCustomer = slice.actions.setCustomer;
exports.setCustomer = setCustomer;
var customerReducer = slice.reducer;
exports.customerReducer = customerReducer;
